import { ArrowRight } from "lucide-react";

export const Hero = () => {
    return (
        <header
            id="inicio"
            data-testid="hero-section"
            className="pt-20 pb-16 border-b border-[#1e2430]"
        >
            <div className="max-w-6xl mx-auto px-6">
                <div className="flex items-center gap-2 mb-6 reveal-delay-1">
                    <span className="w-2 h-2 rounded-full bg-[#2563eb] animate-pulse" />
                    <span className="code-font text-xs text-blue-400 tracking-wider uppercase">
                        Estúdio de Presença Digital &amp; Interface
                    </span>
                </div>

                <h1 className="display-type text-5xl sm:text-7xl lg:text-8xl uppercase leading-[0.95] text-white mb-8 font-semibold">
                    <span className="ln"><span>Sua presença digital</span></span>
                    <span className="ln"><span className="text-[#2563eb]">começa com</span></span>
                    <span className="ln"><span>a Linkora.</span></span>
                </h1>

                <div className="grid md:grid-cols-12 gap-8 items-end pt-4">
                    <div className="md:col-span-7 reveal-delay-2">
                        <p className="text-lg md:text-xl text-slate-300 leading-relaxed max-w-xl">
                            Criamos sites modernos, estratégicos e personalizados para conectar sua
                            marca às oportunidades do mundo digital.
                        </p>
                        <div className="flex flex-wrap gap-4 mt-8">
                            <a
                                href="#orcamento"
                                data-testid="hero-cta-quero-meu-site"
                                className="px-6 py-3.5 bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-medium text-sm rounded-lg transition-colors shadow-lg shadow-blue-600/30 flex items-center gap-2 group"
                            >
                                Quero meu site
                                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                            </a>
                            <a
                                href="#portfolio"
                                data-testid="hero-cta-projetos"
                                className="px-6 py-3.5 bg-[#131822] hover:bg-[#1b2230] border border-[#263142] text-slate-200 font-medium text-sm rounded-lg transition-colors"
                            >
                                Conheça nossos projetos
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-5 reveal-delay-3">
                        <div className="relative rounded-xl overflow-hidden border border-[#263142] bg-[#111722] p-1 d1-frame-wipe">
                            <div className="h-48 rounded-lg relative overflow-hidden">
                                <img
                                    src="https://images.unsplash.com/photo-1689443111130-6e9c7dfd8f9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHRlY2glMjBkYXNoYm9hcmQlMjBpbnRlcmZhY2UlMjBkYXJrJTIwZ2VvbWV0cmljJTIwZ2xvd2luZ3xlbnwwfHx8fDE3OTE5NDkwNDJ8MA&ixlib=rb-4.1.0&q=85"
                                    alt="Interface digital em modo escuro com linhas geométricas"
                                    className="absolute inset-0 w-full h-full object-cover opacity-70"
                                    loading="eager"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0c10]/90 via-[#0a0c10]/30 to-transparent" />
                                <div className="absolute inset-0 p-4 flex flex-col justify-between">
                                    <div className="flex justify-between items-center text-[10px] code-font text-blue-300">
                                        <span>ESTÚDIO // PROJETO REAL</span>
                                        <span>STATUS: OPERACIONAL</span>
                                    </div>
                                    <div className="bg-black/60 backdrop-blur-sm p-3 rounded border border-white/10">
                                        <span className="text-xs font-bold text-white block">
                                            Precisão &amp; Performance Digital
                                        </span>
                                        <span className="text-[11px] text-slate-300">
                                            Construído em código limpo e arquitetura premium.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};
